import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const currency = document.documentElement.lang === 'pl' ? 'pl-PL' : 'en-US';
const formatMoney = cents => new Intl.NumberFormat(currency, {style: 'currency', currency: 'USD'}).format(cents / 100);
const updateShipping = cart => {
  document.querySelectorAll('[data-premium-shipping]').forEach(goal => {
    const target = Number(goal.dataset.target);
    const remaining = Math.max(0, target - cart.total_price);
    goal.querySelector('[data-goal-message]').textContent = remaining ? goal.dataset.remaining.replace('[amount]', formatMoney(remaining)) : goal.dataset.unlocked;
    goal.querySelector('progress').value = Math.min(target, cart.total_price);
  });
};
document.addEventListener('submit', async event => {
  const form = event.target.closest('[data-premium-form]');
  if (!form) return;
  event.preventDefault();
  if (form.dataset.busy === 'true') return;
  form.dataset.busy = 'true';
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('[role="status"]');
  const original = button.innerHTML;
  button.disabled = true;
  button.textContent = button.dataset.adding;
  status.textContent = '';
  const data = new FormData(form);
  const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId))];
  data.set('sections', sections.join(','));
  data.set('sections_url', location.pathname);
  const deferred = CartLinesUpdateEvent.createPromise();
  deferred.promise.catch(() => {});
  form.dispatchEvent(new CartLinesUpdateEvent({action: 'add', context: 'product', lines: [{merchandiseId: String(data.get('id')), quantity: 1}], promise: deferred.promise}));
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {method:'POST',headers:{Accept:'application/json'},body:data});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || status.dataset.error);
    let cart;
    try {
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers:{Accept:'application/json'}});
      if (!cartResponse.ok) throw new Error('Cart refresh failed');
      cart = await cartResponse.json();
    } catch (error) {
      window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      return;
    }
    deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'product-form-component',sourceId:form.id,itemCount:1,productId:form.dataset.productId,sections:result.sections,didError:false}});
    updateShipping(cart);
    button.textContent = button.dataset.added;
    status.textContent = '';
    setTimeout(() => {if(button.isConnected) button.innerHTML=original;},2200);
  } catch (error) {
    deferred.reject(error);
    status.textContent = error.message || status.dataset.error;
    button.innerHTML = original;
  } finally {
    button.disabled=false;
    delete form.dataset.busy;
  }
});
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  event.promise?.then(() => fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then(response => response.json()).then(updateShipping)).catch(() => {});
});
document.addEventListener('click', event => {
  const link = event.target.closest('a[href="#premium-categories"]');
  if (link) {
    const target = document.getElementById('premium-categories');
    if (target) {event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
  }
});
